import type { ContentBuilder } from '../../ui/ContentBuilder';
import type { SettlementView } from '../utils';
import { t, type Language } from '../../../i18n/translations';

function formatTool(lang: Language, tool: SettlementView['inventory']['tools'][number]): string {
    return t(lang, 'tools.item', tool.id, tool.durability);
}

export function renderToolsTab(
    builder: ContentBuilder,
    settlement: SettlementView,
    lang: Language,
): void {
    builder.section(t(lang, 'tools.unassigned'), (section) => {
        if (settlement.inventory.tools.length === 0) {
            section.text(t(lang, 'tools.noneStorage'));
            return;
        }
        settlement.inventory.tools.forEach((tool) => section.text(`- ${formatTool(lang, tool)}`));
    });

    builder.section(t(lang, 'tools.farmers'), (section) => {
        if (settlement.tools.farmers.length === 0) {
            section.text(t(lang, 'tools.noneAssigned'));
            return;
        }
        settlement.tools.farmers.forEach((tool) => section.text(`- ${formatTool(lang, tool)}`));
    });

    builder.section(t(lang, 'tools.hunters'), (section) => {
        if (settlement.tools.hunters.length === 0) {
            section.text(t(lang, 'tools.noneAssigned'));
            return;
        }
        settlement.tools.hunters.forEach((tool) => section.text(`- ${formatTool(lang, tool)}`));
    });
}
